import { ValidationErrorData } from '../typings/common';

export const OPEN_ITEMS_LIST_TEXTAREA_EDITOR = 'OPEN_ITEMS_LIST_TEXTAREA_EDITOR';
export type OPEN_ITEMS_LIST_TEXTAREA_EDITOR = typeof OPEN_ITEMS_LIST_TEXTAREA_EDITOR;

export interface OpenItemsListTextareaEditor {
    type: OPEN_ITEMS_LIST_TEXTAREA_EDITOR;
    editorId: string;
    value: string;
}

export function openItemsListTextareaEditor(editorId: string, value: string): OpenItemsListTextareaEditor {
    return {
        type: OPEN_ITEMS_LIST_TEXTAREA_EDITOR,
        editorId,
        value
    };
}

export const CLOSE_ITEMS_LIST_TEXTAREA_EDITOR = 'CLOSE_ITEMS_LIST_TEXTAREA_EDITOR';
export type CLOSE_ITEMS_LIST_TEXTAREA_EDITOR = typeof CLOSE_ITEMS_LIST_TEXTAREA_EDITOR;

export interface CloseItemsListTextareaEditor {
    type: CLOSE_ITEMS_LIST_TEXTAREA_EDITOR;
    editorId: string;
}

export function closeItemsListTextareaEditor(editorId: string): CloseItemsListTextareaEditor {
    return {
        type: CLOSE_ITEMS_LIST_TEXTAREA_EDITOR,
        editorId
    };
}

export const UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_INPUT = 'UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_INPUT';
export type UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_INPUT = typeof UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_INPUT;

export interface UpdateItemsListEditorTextAreaInput {
    type: UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_INPUT;
    editorId: string;
    value: string;
    shouldClearInputErrors: boolean;
}

export function updateItemsListEditorTextAreaInput(
    editorId: string,
    value: string,
    shouldClearInputErrors: boolean
): UpdateItemsListEditorTextAreaInput {
    return {
        type: UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_INPUT,
        editorId,
        value,
        shouldClearInputErrors
    };
}

export const UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_ERRORS = 'UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_ERRORS';
export type UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_ERRORS = typeof UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_ERRORS;

export interface UpdateItemsListEditorTextAreaErrors {
    type: UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_ERRORS;
    editorId: string;
    errors?: ValidationErrorData[];
}

export function updateItemsListEditorTextAreaErrors(
    editorId: string,
    errors?: ValidationErrorData[]
): UpdateItemsListEditorTextAreaErrors {
    return {
        type: UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_ERRORS,
        editorId,
        errors
    };
}

export type ItemsListTextareaEditorAction =
    | OpenItemsListTextareaEditor
    | CloseItemsListTextareaEditor
    | UpdateItemsListEditorTextAreaInput
    | UpdateItemsListEditorTextAreaErrors;
